import { useEffect, useRef, useState } from 'react';
import './styles.scss';
import { authorizationStore } from '../../../../modules/authorization/authorization.store';

export const ResendPiece: React.FC<{ func: string }> = ({ func }) => {
  const [timer, setTimer] = useState<number>(60);
  const intervalRef = useRef<any>(null);
  const [resend, setResend] = useState<boolean>(false);
  const resendCode = () => {
    (authorizationStore[func as keyof typeof authorizationStore] as Function)();
    startTimer();
  };

  const startTimer = () => {
    setResend(false);
    setTimer(60);
    intervalRef.current = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
  };
  useEffect(() => {
    startTimer();
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (timer === 0) {
      clearInterval(intervalRef.current);
      setResend(true);
    }
  }, [timer]);

  return (
    <div className="recoverSubRow">
      <p className="RecoverInformationText">
        Didn’t receive the code?
        {resend ? (
          <span className="informationWhiteText" onClick={resendCode}>
            {' '}
            Resend{' '}
          </span>
        ) : (
          <span className="recoverNumText"> {timer} </span>
        )}
      </p>
    </div>
  );
};
